import React from 'react';

// Icono de cultivo
export const CropIcon = (props) => (
  <svg
    {...props} // Permite pasar props como className, style, etc.
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="24"
    height="24"
    fill="currentColor"
  >
    {/* Terreno */}
    <path d="M2 48c10-8 20-8 30 0 10-8 20-8 30 0" stroke="currentColor" strokeWidth="2" fill="none" />
    <path d="M2 56c10-8 20-8 30 0 10-8 20-8 30 0" stroke="currentColor" strokeWidth="2" fill="none" />
    {/* Planta */}
    <path d="M32 32v16" stroke="currentColor" strokeWidth="2" fill="none" />
    <path d="M32 32c-6-2-10-8-10-14 6 0 10 4 10 14z" fill="currentColor" />
    <path d="M32 32c6-2 10-8 10-14-6 0-10 4-10 14z" fill="currentColor" />
  </svg>
);

export const PhenologicalStageIcon = (props) => (
  <svg
    {...props} // permite className, style, width, height, etc.
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="20"
    height="20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    focusable="false"
    aria-hidden="true"
  >
    {/* Línea de suelo */}
    <path d="M3 18.5H21" />

    {/* Brote 1 (etapa temprana) */}
    <path d="M6.5 15.5v-3.2" />                          {/* tallo */}
    <path d="M6.5 12.3c-1-.3-1.8-1.3-1.8-2.4 1.2 0 1.8.8 1.8 2.4z" fill="currentColor" stroke="none" /> {/* hoja izq */}
    <path d="M6.5 12.3c1-.3 1.8-1.3 1.8-2.4-1.2 0-1.8.8-1.8 2.4z" fill="currentColor" stroke="none" />   {/* hoja der */}

    {/* Brote 2 (etapa intermedia) */}
    <path d="M12 15.5v-4.2" />                           {/* tallo */}
    <path d="M12 11.3c-1.4-.4-2.4-1.8-2.4-3.2 1.6 0 2.4 1.2 2.4 3.2z" fill="currentColor" stroke="none" />
    <path d="M12 11.3c1.4-.4 2.4-1.8 2.4-3.2-1.6 0-2.4 1.2-2.4 3.2z" fill="currentColor" stroke="none" />

    {/* Brote 3 (etapa avanzada) */}
    <path d="M17.5 15.5V10" />                           {/* tallo */}
    <path d="M17.5 10c-1.7-.5-3-2.2-3-4 2 0 3 1.5 3 4z" fill="currentColor" stroke="none" />
    <path d="M17.5 10c1.7-.5 3-2.2 3-4-2 0-3 1.5-3 4z" fill="currentColor" stroke="none" />
  </svg>
);

export const CultivationEnvironmentIcon = (props) => (
  <svg
    {...props} // permite className, style, width/height, etc.
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="20"
    height="20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    focusable="false"
    aria-hidden="true"
  >
    {/* Contorno tipo invernadero */}
    <path d="M4 11a8 8 0 0116 0v6a3 3 0 01-3 3H7a3 3 0 01-3-3v-6z" />
    {/* Línea del suelo */}
    <path d="M4 16h16" />
    {/* Tallo */}
    <path d="M12 12v5" />
    {/* Hoja izquierda (rellena para contraste en tamaños pequeños) */}
    <path d="M12 12c-2-.5-3.5-2.5-3.5-4.5 2 0 3.5 1.5 3.5 4.5z" fill="currentColor" stroke="none" />
    {/* Hoja derecha */}
    <path d="M12 12c2-.5 3.5-2.5 3.5-4.5-2 0-3.5 1.5-3.5 4.5z" fill="currentColor" stroke="none" />
    {/* Sol (condiciones ambientales) */}
    <circle cx="17.5" cy="6.5" r="1.2" />
  </svg>
);

export const SystemTypeIcon = (props) => (
  <svg
    {...props} // permite className, style, width, height, etc.
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="20"
    height="20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    focusable="false"
    aria-hidden="true"
  >
    {/* Engranaje simplificado */}
    <circle cx="12" cy="12" r="3.2" /> {/* núcleo */}
    {/* dientes del engranaje */}
    <path d="M12 6.2v1.6" />
    <path d="M12 16.2v1.6" />
    <path d="M6.2 12h1.6" />
    <path d="M16.2 12h1.6" />
    <path d="M8.4 8.4l1.1 1.1" />
    <path d="M14.5 14.5l1.1 1.1" />
    <path d="M15.6 8.4l-1.1 1.1" />
    <path d="M9.5 14.5l-1.1 1.1" />

    {/* Nodos del sistema */}
    <circle cx="5" cy="5" r="1.4" fill="currentColor" stroke="none" />
    <circle cx="19" cy="5" r="1.4" fill="currentColor" stroke="none" />
    <circle cx="12" cy="20" r="1.4" fill="currentColor" stroke="none" />

    {/* Conexiones entre nodos y el engranaje (centro) */}
    <path d="M6 6 L10 10" />
    <path d="M18 6 L14 10" />
    <path d="M12 18.4 L12 15.2" />
  </svg>
);

export const SoilTypeIcon = (props) => (
  <svg
    {...props} // permite className, style, width, height, etc.
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="20"
    height="20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    focusable="false"
    aria-hidden="true"
  >
    {/* Borde inferior para “corte” del suelo */}
    <path d="M3 18.5h18" />

    {/* Capas onduladas del suelo */}
    <path d="M3 7.5c2 1 4 1 6 0s4-1 6 0 4 1 6 0" />
    <path d="M3 11.5c2 1 4 1 6 0s4-1 6 0 4 1 6 0" />
    <path d="M3 15.5c2 1 4 1 6 0s4-1 6 0 4 1 6 0" />

    {/* Textura: pequeñas “piedras” (rellenas para verse a 20px) */}
    <circle cx="6.2" cy="13.3" r="1" fill="currentColor" stroke="none" />
    <circle cx="9.8" cy="9.3" r="0.9" fill="currentColor" stroke="none" />
    <circle cx="14.2" cy="13.9" r="0.85" fill="currentColor" stroke="none" />
    <circle cx="17.6" cy="10.1" r="0.9" fill="currentColor" stroke="none" />
  </svg>
);

export const HydroponicSystemTypeIcon = (props) => (
  <svg
    {...props} // permite className, style, width, height, etc.
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="20"
    height="20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    focusable="false"
    aria-hidden="true"
  >
    {/* Canal/bandeja */}
    <rect x="3" y="11" width="18" height="7" rx="2" ry="2" />

    {/* Superficie de la solución nutritiva (onda simple) */}
    <path d="M4 14c1.2.8 2.4.8 3.6 0s2.4-.8 3.6 0 2.4.8 3.6 0 2.4-.8 3.6 0" />

    {/* Tallo y hojas sobre la cubierta */}
    <path d="M12 6.5v4.5" /> {/* tallo */}
    <path d="M12 8.2c-1-.3-1.8-1.3-1.8-2.4 1.2 0 1.8.8 1.8 2.4z" fill="currentColor" stroke="none" /> {/* hoja izq */}
    <path d="M12 8.2c1-.3 1.8-1.3 1.8-2.4-1.2 0-1.8.8-1.8 2.4z" fill="currentColor" stroke="none" />   {/* hoja der */}

    {/* Orificio de net pot / tapa */}
    <circle cx="12" cy="11" r="1.2" fill="currentColor" stroke="none" />

    {/* Raíces dentro de la solución (trazos cortos para legibilidad) */}
    <path d="M12 12.4v1.6" />
    <path d="M12 14l-1 .9" />
    <path d="M12 14l1 .9" />

    {/* Burbujas aireación (indicando sistema hidropónico) */}
    <circle cx="7.2" cy="15.3" r="0.7" fill="currentColor" stroke="none" />
    <circle cx="16.8" cy="15.9" r="0.6" fill="currentColor" stroke="none" />
  </svg>
);